<template>
  <div
    v-if="showLoadingState < 2"
    key="loadingState"
  >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else
    key="billingFiscalAuthorizer"
  >
    <h3>{{ $t('mEditionBillingFiscalAuthorizer.title.first') }}</h3>
    <div class="m-list-integrations m-list-integrations-separate">
      <article
        v-for="autorizador in autorizadoresFiscales"
        :key="autorizador.id"
        class="m-card-primary m-card-transition m-list-integrations-item"
        @click.prevent="selectAutorizadorFiscal(autorizador)"
      >
        <div class="m-list-integrations-item-actions m-list-integrations-item-actions-billing">
          <span>{{ $t('mEditionBillingFiscalAuthorizer.action') }}</span>
        </div>
        <img
          :src="require(`@/assets/img/authorizers/${autorizador.nombre.toLowerCase().replace(' ', '')}.png`)"
        >
        <h5>{{ autorizador.nombre }}</h5>
      </article>
    </div>

    <h3 v-if="academiaAutorizadoresConfigurados.length">
      {{ $t('mEditionBillingFiscalAuthorizer.title.second') }}
    </h3>
    <div
      v-if="academiaAutorizadoresConfigurados.length"
      class="m-table-primary"
    >
      <table>
        <tr>
          <th class="text-align-left">
            {{ $t('mEditionBillingFiscalAuthorizer.table.thName') }}
          </th>
          <th class="text-align-center">
            {{ $t('mEditionBillingFiscalAuthorizer.table.thEdit') }}
          </th>
          <th class="text-align-center">
            {{ $t('mEditionBillingFiscalAuthorizer.table.thActive') }}
          </th>
        </tr>
        <tr
          v-for="autorizador in academiaAutorizadoresConfigurados"
          :key="autorizador.id"
          class="row-data"
        >
          <td class="display-flex-row-center text-align-left">
            <img
              alt="autorizador.nombre"
              class="border-radius-medium margin-right-small height-60-px width-60-px"
              :src="require(`@/assets/img/authorizers/${findAuthorizerById(autorizador.autorizador_fiscal).nombre.toLowerCase().replace(' ', '')}.png`)"
            >
            {{ autorizador.descripcion }}
          </td>
          <td class="text-align-center">
            <AtomButtonIconRounded
              :button-icon-rounded="buttonIconRounded.edit"
              :element="autorizador"
              @editAutorizador="editAutorizador(autorizador)"
            />
          </td>
          <td class="text-align-center">
            <AtomTogglePrimary
              v-model="autorizador.activa"
              :disabled="requests.updateAcademiaAutorizadorEstado.isRequested"
              :element-id="autorizador.id"
              method="updateAcademiaAutorizadorEstado"
              name="activa"
              :show-loading="requests.updateAcademiaAutorizadorEstado.isRequested &&
                requests.updateAcademiaAutorizadorEstado.itemLoading === autorizador.id"
              sliderClass="a-toggle-slider-billing-primary"
              type="checkbox"
              @updateAcademiaAutorizadorEstado="updateAcademiaAutorizadorEstado"
            />
          </td>
        </tr>
      </table>
      <MoleculePaginationPrimary :pagination="pagination"/>
    </div>

  </div>

</template>

<script>
export default {
  name: 'MoleculeEditionBillingFiscalAuthorizer',

  components: {
    MoleculePaginationPrimary: () => import('@/components/molecules/MoleculePaginationPrimary')
  },

  data () {
    return {
      academiaId: '',
      autorizadoresFiscales: [],
      academiaAutorizadoresConfigurados: [],

      buttonIconRounded: {
        delete: {
          class: 'a-button-secondary a-button-danger-secondary a-button-icon-rounded a-tooltip-primary a-tooltip-bottom',
          component: 'MoleculeEditionBillingFiscalAuthorizerModalDelete',
          icon: 'fas fa-trash-alt',
          method: 'showModal',
          tooltip: this.$t('mEditionBillingFiscalAuthorizer.tooltip.delete'),
          type: 'button'
        },

        edit: {
          class: 'a-button-secondary a-button-billing-secondary a-button-icon-rounded a-tooltip-primary a-tooltip-bottom',
          component: '',
          icon: 'fas fa-info',
          method: 'editAutorizador',
          tooltip: this.$t('mEditionBillingFiscalAuthorizer.tooltip.edit'),
          type: 'button'
        },

        data: {
          class: 'a-button-secondary a-button-billing-secondary a-button-icon-rounded a-tooltip-primary a-tooltip-bottom',
          component: 'MoleculeEditionBillingFiscalAuthorizerModalConfigurationData',
          icon: 'fas fa-clipboard-list',
          method: 'showModal',
          tooltip: this.$t('mEditionBillingFiscalAuthorizer.tooltip.data'),
          type: 'button'
        }
      },

      pagination: {
        currentPage: 1,
        currentQuantity: 0,
        limit: 10,
        showLoadingState: false,
        totalPages: 1,
        totalQuantity: 0
      },

      requests: {
        updateAcademiaAutorizadorEstado: {
          itemLoading: '',
          isRequested: false
        }
      },

      showLoadingState: 0
    }
  },

  computed: {
    updatedData () {
      return this.$modal.updatedData
    }
  },

  watch: {
    updatedData () {
      this.showLoadingState--
      this.readAcademiaAutorizadoresConfiguradas()
    }
  },

  created () {
    this.academiaId = this.$store.getters.getAcademyData.id
    this.readAutorizadoresFiscales()
    this.readAcademiaAutorizadoresConfiguradas()
  },

  methods: {
    asignarImagenes () {
      this.academiaAutorizadoresConfigurados.forEach(config => {
        const fiscal = this.autorizadoresFiscales.find(
          f => f.id === config.autorizador_fiscal
        )
        if (fiscal) {
          config.imagen = fiscal.imagen
        } else {
          config.imagen = '/images/default.png'
        }
      })
    },

    editAutorizador (autorizador) {
      this.$store.commit('setBillingFiscalAuthorizerEdit', autorizador)
      this.$router.push(`/${this.$t('rPaths.billing')}/${this.$t('mEditionMenu.billing.fiscalAuthorizer.subject')}/${this.$t('mEditionMenu.billing.fiscalAuthorizer.children.editAuthorizer.subedition')}`)
    },

    findAuthorizerById (id) {
      return this.autorizadoresFiscales.find(auth => auth.id === id)
    },

    readAcademiaAutorizadoresConfiguradas () {
      this.$services.read('parametro', 'readAutorizadoresConfigurados', {}, [this.academiaId])
        .then(response => {
          this.academiaAutorizadoresConfigurados = response.data
          this.pagination.currentQuantity = this.academiaAutorizadoresConfigurados.length
          this.pagination.totalQuantity = this.academiaAutorizadoresConfigurados.length
          this.showLoadingState++
        }).catch((error) => {
          this.showLoadingState++
          console.error(error)
        })

      this.asignarImagenes()
      return this.academiaAutorizadoresConfigurados
    },

    readAutorizadoresFiscales () {
      this.$services.read('parametro', 'readAutorizadoresFiscales', {})
        .then(response => {
          this.autorizadoresFiscales = response.data
          this.showLoadingState++
        }).catch((error) => {
          this.showLoadingState++
          console.error(error)
        })
      return this.autorizadoresFiscales
    },

    selectAutorizadorFiscal (autorizador) {
      this.$store.commit('setBillingFiscalAuthorizer', autorizador)
      this.$router.push(`/${this.$t('rPaths.billing')}/${this.$t('mEditionMenu.billing.fiscalAuthorizer.subject')}/${this.$t('mEditionMenu.billing.fiscalAuthorizer.children.connectAuthorizer.subedition')}`)
    },

    updateAcademiaAutorizadorEstado (element) {
    }
  }
}
</script>
